import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
  text:{
    fontSize: 30,
    textAlign: 'center',
    color:'#444444',
  },
})

class NameInput extends Component{
  state = {
    name: "",
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };
  handleTextFieldKeyDown = event => {
    switch (event.key) {
      case 'Enter':
          this.props.enterHandler(this.state.name)
        break;
      default: break;

    }
  }
  render(){
    const { classes } = this.props;
    return (
      <ReactCSSTransitionGroup
        className="container result"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >
        <div>
        <h3 className={classes.text}>氏名を入力してください。</h3>
        <TextField
          id="name"
          label="name"
          onChange={this.handleChange('name')}
          onKeyDown={this.handleTextFieldKeyDown}
          margin="normal"
        />

        </div>
      </ReactCSSTransitionGroup>
    );
  }
}

export default withStyles(styles, { withTheme: true })(NameInput);



// WEBPACK FOOTER //
// ./src/components/quiz/NameInput.js